import type { MarketingResource } from "creso-core/types";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useMemo } from "react";
import { Button, Dialog, DialogContent, DialogTitle } from "web-design-system";
import { MarketingCreativePreviewPanel } from "./marketing-creative-preview";

type MarketingPosterPreviewDialogProps = {
  items: MarketingResource[];
  selectedId: number | null;
  onSelectedIdChange: (id: number | null) => void;
};

export function MarketingPosterPreviewDialog({
  items,
  selectedId,
  onSelectedIdChange,
}: MarketingPosterPreviewDialogProps) {
  const selectedIndex = useMemo(
    () => items.findIndex((item) => item.id === selectedId),
    [items, selectedId]
  );
  const selectedItem = selectedIndex >= 0 ? items[selectedIndex] : null;
  const canNavigateItems = items.length > 1;

  if (!selectedItem) {
    return null;
  }

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) {
          onSelectedIdChange(null);
        }
      }}
    >
      <DialogContent className="w-[95vw] max-w-[420px] gap-4 rounded-3xl p-3">
        <DialogTitle className="sr-only">
          {selectedItem.title} creative preview
        </DialogTitle>

        {canNavigateItems ? (
          <Button
            type="button"
            size="icon"
            variant="outline"
            className="absolute -left-12 top-1/2 z-10 size-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-background [&_svg]:size-5"
            onClick={() =>
              onSelectedIdChange(
                items[(selectedIndex - 1 + items.length) % items.length]?.id ??
                  null
              )
            }
          >
            <ChevronLeft className="h-10 w-10" />
          </Button>
        ) : null}

        {canNavigateItems ? (
          <Button
            type="button"
            size="icon"
            variant="outline"
            className="absolute -right-12 top-1/2 z-10 size-10 translate-x-1/2 -translate-y-1/2 rounded-full bg-background [&_svg]:size-5"
            onClick={() =>
              onSelectedIdChange(
                items[(selectedIndex + 1) % items.length]?.id ?? null
              )
            }
          >
            <ChevronRight className="h-10 w-10" />
          </Button>
        ) : null}

        <MarketingCreativePreviewPanel item={selectedItem} />
      </DialogContent>
    </Dialog>
  );
}
